/**
 * @mixin
 * Handles receiveing posted messages from AccessWeb pages that are being iframed
 */
export default {
	data() {
		return {
			accessModalAction: 'vue-ui-modal',
			accessMessageAction: 'vue-ui-iframe'
		};
	},
	created() {
		window.addEventListener('message', this.onMessageMixin);
		this.listen = true;
	},
	methods: {
		onMessageMixin(message) {
			if (
				message &&
				message.data &&
				message.data.source === 'AccessToVue'
			) {
				let action;

				if (message.data.data) {
					action = message.data.data.action;
				}

				switch (action) {
					case this.accessModalAction:
						if (typeof this.onModalMessage === 'function') {
							this.onModalMessage(message.data.data);
						}

						break;
					default:
						if (typeof this.onMessage === 'function') {
							this.onMessage(message.data.data);
						}
						break;
				}
			}
		},
		postIFrameReadyMessageToAccess() {
			this.postMessageToAccess({
				target: this.accessMessageAction,
				action: 'iframeReadyForModal'
			});
		},
		postCloseMessageToAccess() {
			this.postMessageToAccess({
				target: this.accessMessageAction,
				action: 'close'
			});
		},
		postCustomEventMessageToAccess(eventName, args) {
			this.postMessageToAccess({
				target: this.accessMessageAction,
				action: 'dispatchCustomEvent',
				event: eventName,
				args: args, //adding both args and data props to resolve merge conflict of Honda flat rate and GM Rewards
				data: args //adding both args and data props to resolve merge conflict of Honda flat rate and GM Rewards
			});
		},
		postTostMessageToAccess(toast) {
			this.postMessageToAccess({
				target: this.accessMessageAction,
				action: 'showToast',
				toast: toast
			});
		},
		postOpenWindowMessageToAccess(data) {
			this.postMessageToAccess({
				target: this.accessMessageAction,
				action: 'openWindow',
				args: data
			});
		},
		postMessageToAccess(data) {
			const message = { source: 'VueToAccess', data: data };
			const host = window.location.hostname;
			const protocol = window.location.protocol;
			const port = window.location.port;
			let target = `${protocol}//${host}`;

			if (port) {
				target = target + ':' + port;
			}

			window.parent.postMessage(message, target);
		}
	},
	destroyed() {
		window.removeEventListener('message', this.onMessage);
	}
};
